import { InsightsHubArticle } from "@insightsHub/models/insightsHubArticle.model";
import {
  InsightsHubArticleResponseAttributes,
  InsightsHubArticleResponseDto,
  isInsightsHubArticleV4,
} from "@insightsHub/models/response.model";

type StrapiMedia = NonNullable<InsightsHubArticleResponseAttributes["Content_Image"]>;

const getMediaUrl = (media?: StrapiMedia | null): string | undefined => {
  if (!media) {
    return undefined;
  }

  if (typeof media.url === "string") {
    return media.url;
  }

  return media.data?.attributes?.url;
};

const getArticleAttributes = (articleDto: InsightsHubArticleResponseDto): InsightsHubArticleResponseAttributes =>
  isInsightsHubArticleV4(articleDto) ? articleDto.attributes : articleDto;

export const mapStrapiPortalArticle = (articleDto: InsightsHubArticleResponseDto): InsightsHubArticle => {
  const attributes = getArticleAttributes(articleDto);

  return {
    id: articleDto.id,
    documentId: isInsightsHubArticleV4(articleDto) ? undefined : articleDto.documentId,
    authorName: attributes.Author_Name ?? "",
    authorTitle: attributes.Author_Title ?? "",
    authorName2: attributes.Author_Name2 ?? "",
    authorTitle2: attributes.Author_Title2 ?? "",
    authorName3: attributes.Author_Name3 ?? "",
    authorTitle3: attributes.Author_Title3 ?? "",
    title: attributes.Title ?? "N/A",
    content: attributes.Content ?? "N/A",
    shortDescription: attributes.ShortDescription ?? "",
    publishDate: attributes.Effective_Published_Date ?? "",
    contentType: attributes.Content_Type ?? "",
    contentImage: getMediaUrl(attributes.Content_Image) ?? "",
    homepageImage: getMediaUrl(attributes.Homepage_Image) ?? "",
    businessSegmenstMultiSelect: attributes.Business_Segment_Type,
    featuredArticle: attributes.Featured_Article ?? false,
    articleType: attributes.Article_Type ?? "",
  };
};
